<template>
  <div id="app" class="gametool-app">
    <router-view />
  </div>
</template>

<script>

export default {
  name: 'app',
  components: {

  }
}
</script>

<style lang="scss">
.gametool-app {
  height: 100%;
  width: 100%;
  margin: 0;
  padding: 0;
}
html, body {
  height: 100%;
  margin: 0;
}
</style>
